import React from 'react';

export interface IUpdateProps {
  className?: string;
}

export const UpdateIcon: React.FC<IUpdateProps> = ({ className }) => {
  return (
    <svg width="20" height="20" fill="none" className={className}>
      <path
        d="m15.143 9.537 1.428 1.53L18 9.537"
        stroke="#99A1AB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.243 4.166A6.64 6.64 0 0 1 10 3a6.703 6.703 0 0 1 6.571 8.016M4.857 9.731 3.43 8.203 2 9.731"
        stroke="#99A1AB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.756 15.104A6.633 6.633 0 0 1 10 16.268a6.703 6.703 0 0 1-6.572-8.016"
        stroke="#99A1AB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
